import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import {
    VerificationService,
    getLogoUrl,
    LogoComponent,
    SegmentEnum,
} from '@sheerid/jslib';
import { FormFooterComponent } from '../FormFooterComponent';


interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const hasLogo = getLogoUrl(verificationService.programTheme) ? true : false;
    const { segment } = verificationService.verificationResponse;

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    {
                        segment === SegmentEnum.MILITARY ?
                            <FormattedHTMLMessage id="step.success.military.title" defaultMessage="Success! You've been verified." />
                        :
                            <FormattedHTMLMessage id="step.success.stateDepartment.title" defaultMessage="Success! You've been verified." />
                    }
                </div>
                <div className="sid-header__subtitle">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage="Your documentation was successfully verified, and Google Fi is now processing your international exception. This usually takes a few minutes, but up to a day in some cases. You'll get a confirmation email when it's approved."
                    />
                </div>
            </div>

            <hr className="sid-l-horz-separator sid-l-space-top-md"></hr>

            <FormFooterComponent verificationService={verificationService} />
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;

